"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const trans_1 = require("@common/tsutils/trans");
class OrderConfig {
    constructor() {
        // The type of order
        this.type = 'boolean';
        // The data origin: core, csv or ranks
        this.origin = 'core';
        // The unique ID - lang independent
        this.id = '';
        // The name
        this.name = '';
        // The path to retrieve the value in the sample object
        this.sample_path = '';
        this.enabled = true;
    }
    update(library) {
        if (!library.length) {
            this.enabled = false;
            return;
        }
        const samplesWithValues = library.map(sample => {
            let option = sample.retrieveValueForFilterOrGroup(this);
            if (option === undefined)
                option = null;
            return option;
        }).filter(option => option !== null);
        this.enabled = samplesWithValues.length > 1;
    }
    static newOrderConfig(type, id, path, name) {
        const f = new OrderConfig();
        f.type = type;
        f.id = id;
        f.name = name || (0, trans_1.trans)('heatmap.metadata_items.' + id);
        f.sample_path = path;
        f.origin = name === null ? 'core' : 'csv';
        return f;
    }
    static newBoolean(id, path, name = null) {
        return OrderConfig.newOrderConfig('boolean', id, path, name);
    }
    static newList(id, path, name = null) {
        return OrderConfig.newOrderConfig('list', id, path, name);
    }
    static newNumber(id, path, name = null) {
        return OrderConfig.newOrderConfig('number', id, path, name);
    }
    static newDate(id, path, name = null) {
        return OrderConfig.newOrderConfig('date', id, path, name);
    }
    static newOrderFromMetadata(type, id, name) {
        const f = new OrderConfig();
        f.type = type;
        f.id = id;
        f.name = name;
        f.origin = 'csv';
        return f;
    }
}
exports.default = OrderConfig;
